import { inject, Injectable } from '@angular/core';

import { ORG_GUID } from '@core/tellent-types';
import { injectTellentAppUrlOpener } from '@core/tellent-util';

@Injectable()
export class TellentManageRedirectService {
  private readonly tellentAppUrlOpener = injectTellentAppUrlOpener('_blank');
  private readonly orgGuid = inject(ORG_GUID);

  public sendMembersForPreonboarding(memberGuids: string[]): void {
    if (memberGuids.length > 1) {
      // Send members for bulk journeys creation
      this.tellentAppUrlOpener(
        'core_hr',
        {
          id: 'journeys:create_bulk',
          params: { tellentMemberGuids: memberGuids },
        },
        this.orgGuid!,
      );
    } else {
      // Send single member for journey creation
      this.tellentAppUrlOpener(
        'core_hr',
        {
          id: 'journeys:create',
          params: { tellentMemberGuid: memberGuids[0] },
        },
        this.orgGuid!,
      );
    }
  }
}
